import { DateTime } from "luxon";
function getCurrentISOStringWithTimezone() {
	return DateTime.now().toISO() ?? DateTime.now().toISODate();
}
function getISOStringWithTimezone(e) {
	return e.toISO() ?? e.toISODate();
}
function getISOStringWithTimezoneFromDate(s) {
	return DateTime.fromJSDate(s).toISO() ?? DateTime.fromJSDate(s).toISODate();
}
function dateTimeFromISOString(s) {
	return DateTime.fromISO(s);
}
function dateFromISOString(s) {
	return DateTime.fromISO(s).toJSDate();
}
function getCurrentDateTime() {
	return DateTime.now();
}
function getCurrentDate() {
	return DateTime.now().toJSDate();
}
function isDateDue(s) {
	let c = DateTime.fromISO(s), l = DateTime.now().plus({ days: 1 });
	return c <= DateTime.now().set({
		year: l.year,
		month: l.month,
		day: l.day,
		hour: 0,
		minute: 0,
		second: 0,
		millisecond: 0
	});
}
function getDaysUntilDate(s) {
	let c = DateTime.fromISO(s), l = DateTime.now(), u = c.diff(l, "days").days;
	return Math.ceil(u);
}
function getISODateString(s) {
	return DateTime.fromISO(s).toISODate();
}
export { dateFromISOString, dateTimeFromISOString, getCurrentDate, getCurrentDateTime, getCurrentISOStringWithTimezone, getDaysUntilDate, getISODateString, getISOStringWithTimezone, getISOStringWithTimezoneFromDate, isDateDue };
